export default {
  translation: {
    'shared.french': 'English',
    'app.name': 'Espace client Regain',
    'auth.hero': "Bienvenue sur\nvotre espace client Mon Accompagnateur Rénov'",
  },
  global: {
    'Internal server error':
      "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
    hero: 'Bienvenue sur votre espace client',
    password: 'Mot de passe',
    email: 'E-mail',
    logout: 'Se déconnecter',
    cancel: 'Annuler',
    close: 'Fermer',
    back: 'Retour',
    yes: 'Oui',
    no: 'Non',
    validate: 'Valider',
    required: 'Ce champ est obligatoire',
    rdv: 'Prendre rendez-vous',
    max_file: 'Le fichier ne doit pas dépasser {{size}}Mo.',
    internet_connexion_error:
      "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
    'email.required': 'Veuillez renseigner une adresse e-mail valide',
    session_expired: 'Votre session a expiré. Veuillez vous reconnecter.',
    files_uploaded_one: 'Fichier envoyé avec succès',
    files_uploaded_other: 'Fichiers envoyés avec succès',
    download_error: 'Une erreur est survenue lors du téléchargement du fichier',
  },
  login: {
    hero: 'Connexion',
    description: 'Renseignez votre adresse email et votre mot de passe',
    forgot: 'Mot de passe oublié',
    login_error: 'Votre identifiant ou votre mot de passe est incorrect',
    submit: 'Se connecter',
  },
  first_login: {
    hero: 'Première connexion',
    description: 'Renseignez votre mot de passe',
    success: 'La création de votre mot de passe a bien été prise en compte.',
    error: "Votre lien à expiré ou n'est plus valide",
    success_description: 'Création de votre mot de passe',
    success_action: 'Se connecter',
    submit: 'Valider',
    password: 'Mot de passe',
    same: 'Les mots de passes ne sont pas identiques',
    'confirm.password': 'Confirmer mot de passe',
    'confirm.regex.error':
      'Le mot de passe doit contenir 8 caractères :\nune majuscule, un chiffre et un caractère spécial.',
    'confirm.placeholder.password': 'Confirmation du mot de passe',
  },
  change_password: {
    hero: 'Réinitialisation de mot de passe',
    description: 'Veuillez renseigner votre nouveau mot de passe',
    submit: 'Valider',
    success: 'Modification du mot de passe',
    success_description: 'Votre mot de passe a bien été réinitialisé',
    success_action: 'Se connecter',
    password: 'Nouveau mot de passe',
    same: 'Les mots de passes ne sont pas identiques',
    'confirm.password': 'Confirmer mot de passe',
    'confirm.regex.error':
      'Le mot de passe doit contenir 8 caractères :\nune majuscule, un chiffre et un caractère spécial.',
    'confirm.placeholder.password': 'Confirmation du mot de passe',
  },
  404: {
    hero: 'Page introuvable',
    description: "La page que vous cherchez n'existe pas ou a été déplacée.",
    back: "Retour à l'accueil",
  },
  reset_password: {
    hero: 'Mot de passe oublié',
    description:
      'Veuillez saisir votre email de connexion afin de recevoir le lien de réinitialisation de votre mot de passe.',
    submit: 'Valider',
    error: "Votre lien à expiré ou n'est plus valide",
    back: 'Retour',
    success: 'Réinitialisation du mot de passe',
    success_alert:
      "Nous vous avons envoyé un e-mail pour réinitialiser votre mot de passe. Pour créer votre nouveau mot de passe, il vous suffit de cliquer sur le lien contenu dans l'e-mail et d'en saisir un nouveau.",
    success_description:
      "<strong>Vous n'avez pas reçu cet e-mail</strong><br> Vérifiez vos courriers indésirables ou contactez :<br>",
  },
  select: {
    all: 'Tout sélectionner',
    none: 'Tout désélectionner',
  },
  file: {
    default_label: 'Fichiers',
    delete: 'Supprimer le fichier {{file}}',
    default_drop_zone_label_one: 'Veuillez charger votre fichier ici',
    default_drop_zone_label_other: 'Veuillez charger vos fichiers ici',
    or: 'ou',
    browse: 'charger depuis vos fichiers',
    supported_types:
      'Taille maximale : 20 Mo. Formats supportés : jpg, png, pdf, doc, docx, xls, xlsx, ppt, pptx. 10 fichiers max.',
    max_size: 'Max',
    max_files_other: '{{count}} fichiers maximum',
    max_files_one: 'Un fichier maximum',
    max_files_zero: 'Aucun fichier restant',
    max_error_files: 'Vous ne pouvez pas envoyer plus de {{maxFiles}} fichiers',

    named_max_error_size_one: 'Le fichier: {{name}}, dépasse 10Mo',
    named_max_error_size_other: 'Les fichiers: {{name}}, dépassent 10Mo',
    size_error_message_one:
      "Le fichier {{fileNames}} n'a pas pu être importé correctement (> {{maxSize}} Mo)",
    size_error_message_other:
      "Les fichiers {{fileNames}} n'ont pas pu être importés correctement (> {{maxSize}} Mo)",
    preview_not_available: "L'aperçu n'est pas disponible",
    preview_not_supported:
      "L'aperçu des fichiers {{type}} n'est pas pris en charge",
  },
  profil: {
    title: 'Mes identifiants',
    subtitle: 'Veuillez renseigner votre nouveau mot de passe',
    identity: 'Identité',
    firstname: 'Prénom',
    mobilephone: 'Téléphone mobile',
    lastname: 'Nom',
    email: 'E-mail',
    update_password: 'Modifier mot de passe',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    validate: 'Valider',
    cancel: 'Annuler',
    change_password_success_title: 'Nouveau mot de passe bien enregistré',
    change_password_success_subtitle:
      'Votre changement de mot de passe a bien été pris en compte',
  },
  project: {
    travaux: 'Nombre de travaux',
    details: 'Voir projet',
    owner: 'Mon interlocuteur',
    build_date: 'Année de construction',
    surface: 'Surface',
    meters: 'm²',
    badge_power: 'Étiquette énergétique',
    project: 'Projet',
    documents: 'Documents',
    my_project: 'Mon projet',
    my_mar: "Mon Accompagnateur Rénov'",
    my_interlocutors: 'Mes interlocuteurs',
    my_interlocutor: 'Mon interlocuteur',
    my_commercial: 'Mon commercial',
    my_admin_helper: 'Mon Assistante Administrative',
    house: 'Logement',
    build_year: 'Année de construction',
    scenario: 'Scénario retenu',
    budget: 'Budget',
    amount: 'Montant des travaux',
    mpra_help: 'Aides MaPrimeRénov’',
    rest: 'Reste à charge',
    power_class: 'Classe énergétique',
    power_class_before: 'Avant projet',
    power_class_after: 'Après projet',
    power_class_gap_other: 'Saut de {{count}} classes énergétiques',
    power_class_gap_one: 'Saut d’une classe énergétique',
    power_class_gap_zero: 'Pas de changement de classe énergétique',
    fiscal_house: 'Foyer',
    fiscal_salary: 'Revenu fiscal',
    mpra: 'MaPrimeRénov’',
    status: {
      available: 'Disponible',
      signed: 'Signé',
      to_plan: 'À planifier',
      in_progress: 'En rédaction',
      non_conforme: 'Non conforme',
      conforme: 'Conforme',
      planned: 'Planifiée au {{date}}',
      at: 'Le ',
      work_end: 'Prévue le {{date}}',
    },
    status_type: {
      visit_1_mar: 'Date de la visite 1 MAR',
      final_visit: 'Date visite finale',
      work_end: 'Date prévisionnelle de fin de chantier',
    },
  },
  travaux: {
    title: 'Travaux',
  },
  documents: {
    upload: 'Importer un fichier',
    title: 'Documents',
    file: 'Fichier',
    file_type: 'Type de fichier',
    actions: 'Actions',
    by_hellio: 'Déposé par Hellio Ingénierie le {{date}}',
    by_me: 'Déposé par moi le {{date}}',
    download: 'Télécharger le fichier',
    update: 'Mettre à jour le fichier',
    empty: "Aucun document n'a été déposé",
  },
  document_modal: {
    placeholder: 'Sélectionner',
    title: 'Importer un fichier',
    description:
      'Veuillez déposer votre document qui sera étudié par votre Accompagnateur Rénov’.',
    category: 'Type de document',
  },
  documents_categories: {
    all: 'Tous les documents',
    devis: 'Devis',
    devis_hellio_inge: 'Devis Hellio Ingénierie',
    preuve_virement: 'Preuve de virement',
    attestation_travaux: 'Attestations',
    piece_administratives: 'Pièces administratives',
    restitution_audit: 'Audit énergétique',
    devis_travaux: 'Devis travaux',
    grille_analyse_logement: "Grille d'analyse du logement",
    plan_financement: 'Plan de financement',
    factures: 'Factures',
    rapport_accompagnement: "Rapport d'accompagnement",
    rapport_de_performance_energetique: 'Rapport de performance énergétique',
    contrat: 'Contrat',
  },
  documents_category: {
    avis_d_imposition__1_: 'Avis d’imposition',
    avis_d_imposition: 'Avis d’imposition',
    fichier_dpe: 'DPE',
    contrat: 'Contrat',
    attestation_sur_l_honneur__proprietaire_bailleurs_:
      "Déclaration sur l'honneur",
    fiches_de_paie: 'Fiches de paie',
    attestation_assurance: 'Attestation assurances',
    audit_energetique: 'Audit énergétique',
    audit_energetique_final: 'Audit énergétique',
    plan_de_financement___rapport_mar: 'Plan de financement final',
    plan_de_financement_previsionnel: 'Bilan financier',
    factures_hi: 'Factures',
    rapport_d_accompagnement__cerfa_anah_: "Rapport d'accompagnement",
    attestation_travaux__devis_: 'Attestation travaux - devis',
    attestation_cee: 'Attestation CEE',
    rib_hi: 'RIB',
    grille_d_analyse_synthese: "Grille d'analyse du logement",
    fichier_devis: 'Devis',
    fichier_devis__1_: 'Devis',
    devis_mar_signe: 'Devis',
    fichier_dpe_presta: 'Pré-audit',
    plans: 'Plan de configuration du bien',
    justificatif_de_propriete: 'Titre de propriété',
    avis_de_virement_hi: 'Preuve de virement',
    attestation_travaux__facture_: 'Attestation travaux - facture',
    rapport_de_performance_energetique: 'Rapport de performance énergétique',
  },
  avatar: {
    avatar_change_success: 'Votre avatar a bien été modifié',
  },
  meeting: {
    cancelled: 'Reunion annulée avec succès',
    title: 'Mon rendez-vous',
    phone_description: 'Le rendez-vous se fera par téléphone.',
    place_description: 'Le rendez-vous se fera sur place',
    video_description: 'Le rendez-vous se fera en visioconférence',
    phone_title: 'Par téléphone',
    place_title: 'Sur place',
    video_title: 'En visioconférence',
    take: 'Prendre rendez-vous',
    cancel: 'Annuler',
    cancel_title: 'Annulation du rendez-vous',
    cancel_description: 'Souhaitez-vous vraiment annuler ce rendez-vous ?',
    reschedule: 'Replannifier',
  },
  steppers: {
    title: 'Suivez votre projet',
    show_all: 'Voir détails',
    hide_all: 'Masquer les détails',
  },
  resend_link_first_login: {
    title: 'Votre lien de connexion a expiré',
    action: 'Recevoir un nouveau lien',
    description:
      'Votre lien de connexion a expiré. Pour des raisons de sécurité, les liens de connexion sont valables uniquement pendant une durée limitée.',
    success_title: 'Votre lien de connexion a été envoyé par mail',
    success_description:
      "<strong>Vous n'avez pas reçu cet e-mail</strong><br> Vérifiez vos courriers indésirables ou contactez :<br>",
  },
  notifications: {
    title: 'Notifications',
    empty: 'Vous n’avez pas de notification',
    DEPOTS_PIECES_ADMINISTRATIVES_title:
      "Veuillez déposer vos pièces administratives pour continuer le traitement de votre dossier (avis d'impositions, DPE si existant, preuve de virement de l'acompte)",
    DEPOSER_DEVIS_title:
      "N'oubliez pas de déposer vos devis pour continuer le traitement de votre dossier.",
    RAPPELER_RDV_title: 'Rappel : Votre rendez-vous est prévu pour demain.',
    PLANIFIER_RDV_title:
      'Planifiez un rendez-vous téléphonique avec votre accompagnateur.trice rénov pour cadrer la visite.',
    CONFIRMATION_SELECTION_SCENARIO_title:
      "Félicitations ! Vous avez sélectionné votre scénario. Vous pouvez maintenant passer à l'étape suivante",
    PRENDRE_CONNAISSANCE_AUDIT_title:
      'Votre Audit est terminé et disponible, prenez-en connaissance dès maintenant !',
    CHANTIER_CONFORME_title: 'Votre chantier est conforme, félicitations !',
  },
};
